import Body from './Body';
import Header from './Header';

const ManufacturerImportItem = {
  Header,
  Body,
};

export default ManufacturerImportItem;
